import axios from '../http/axios';
import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';

export default {
	consultarInfoBackend: () => {
		return axios
			.get(`${PORTAL_SERVICOS_BACKEND}/info`)
			.then(res => { return res.data; });
	}
};
